module.exports = __webpack_public_path__ + "static/media/gorilla_poweredby.4d317cba.png";